<template>
    <home/>
</template>

<script>

    import home from './pc/home';

    export default {
        name: 'Index',
        data() {
            return {
            }
        },
        components: {
            home,
        },
        mounted() {
           // window.addEventListener('scroll', this.handleScroll);
        },
        watch: {

        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
